import styled from "styled-components";

export const customStyle = {
  content: {
    border: "none",
    borderRadius: "6px",
    marginRight: "-50%",
    padding: 0,
    top: "50%",
    right: "auto",
    bottom: "auto",
    left: "50%",
    width: "766px",
    height: "fit-content",
    zIndex: 100,
    transform: "translate(-50%, -50%)",
    overflow: "visible",
    boxShadow: "0 4px 10px 0 rgba(82, 95, 127, 15%)"
  }
};

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 32px 40px;

  > h2 {
    font-family: "Rubik", "sans-serif";
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #1d2939;

    flex: 1 0 auto;
    margin-top: 0 !important;
  }
`;

export const ButtonIcon = styled.button`
  display: inline-block;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: none;
  background: transparent;
  font-family: sans-serif;
  font-size: 1em;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;

  > svg {
    flex: 0 0 auto;
    fill: #98a2b3;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  line-height: 1.4;
  font-size: 16px;
  font-weight: 500;
`;
